import { observer } from 'mobx-react-lite'
import { Error, PhoneWithLabelInput, Typography } from 'shared/ui'
import { type ProfileStore } from 'pages/settings/pages/personal/pages/account/pages/profile'

type ICheckCurrentPasswordModalProps = {
  store: ProfileStore
}

export const ChangePhoneModal = observer(({ store }: ICheckCurrentPasswordModalProps) => {
  const { phoneNewInputStore, errorsMap, removeError, loading } = store
  const phoneError = errorsMap.get('phone_number')

  return (
    <div>
      <Typography
        variant='body-md-medium'
        ariaLabel='Reset password description'
        tag={'div'}
        marginTop={4}
      >
        New phone number
      </Typography>
      <Typography
        variant='body-md-regular'
        color='var(--content-primary-tertiary)'
        ariaLabel='Reset password description'
        tag={'div'}
        marginTop={4}
        marginBottom={24}
      >
        Update the phone number used for your account
      </Typography>
      <PhoneWithLabelInput
        item={phoneNewInputStore.country}
        items={phoneNewInputStore.countries}
        number={phoneNewInputStore.number}
        loading={loading}
        numberError={phoneNewInputStore.numberError}
        isValidNumber={phoneNewInputStore.isValidNumber}
        numberRequestError={phoneNewInputStore.numberRequestError}
        setNumber={(value) => {
          phoneNewInputStore.setNumber(value)
          removeError('phone_number')
        }}
        setCountry={phoneNewInputStore.setCountry}
        triggerNumberValidation={phoneNewInputStore.triggerNumberValidation}
        hideLabel
        disabled={loading}
      />
      <Error type={'text'} error={phoneError} />
    </div>
  )
})
